
export enum AttendeeModalState {
  ListView,
  EditAttendee,
  AddAttendee,
  ImportAttendee,
}
